module.exports = __webpack_public_path__ + "img/bot_bdtd3.eb5994b0.png";